import { TIMELINE_LEGEND_ORDER } from "constants/filingsTimeline";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { matchesLegendFilter } from "utils/filingsTimeline/matchesLegendFilter";
import { TimelineLegendItem } from "./TimelineLegendItem";

type TimelineLegendProps = {
  filings: TimelineFilingRow[];
};

export const TimelineLegend = ({ filings }: TimelineLegendProps) => {
  const items = TIMELINE_LEGEND_ORDER.map((filter) => ({
    filter,
    count: filings.filter((filing) => matchesLegendFilter(filing, filter))
      .length,
  })).filter(({ count }) => count > 0);

  // A year with no filings has no statuses to explain.
  if (items.length === 0) return null;

  return (
    <div className="t-flex t-flex-wrap t-items-center t-gap-6">
      {items.map(({ filter, count }) => (
        <TimelineLegendItem key={filter} filter={filter} count={count} />
      ))}
    </div>
  );
};
